import L from 'leaflet'

/**
 * Calculates the distance between two coordinates
 * Copied from generic.inc.php "DistanceTerrestre"
 * @param {*} la1
 * @param {*} lo1
 * @param {*} la2
 * @param {*} lo2
 * @returns
 */
export function getTerrestrialDistance(la1, lo1, la2, lo2) {
  return calcCrow(la1, lo1, la2, lo2)

  function isZero(x) {
    return Math.abs(x) < 0.00000001
  }

  let cosLa1 = 0.0
  let sinLa1 = 0.0
  let cosLo1 = 0.0
  let sinLo1 = 0.0
  let cosLa2 = 0.0
  let sinLa2 = 0.0
  let cosLo2 = 0.0
  let sinLo2 = 0.0
  let coef = 0.0
  let u = 0.0
  let v = 0.0
  let w = 0.0
  let x1 = 0.0
  let y1 = 0.0
  let z1 = 0.0
  let x2 = 0.0
  let y2 = 0.0
  let z2 = 0.0
  let cosT = 0.0
  let sinT = 0.0
  let teta = 0.0
  let terre = 0.0

  terre = 6367616
  coef = Math.PI / (3600 * 180 * 3000)
  cosLa1 = Math.cos(la1 * coef)
  sinLa1 = Math.sin(la1 * coef)
  cosLa2 = Math.cos(la2 * coef)
  sinLa2 = Math.sin(la2 * coef)
  cosLo1 = Math.cos(lo1 * coef)
  sinLo1 = Math.sin(lo1 * coef)
  cosLo2 = Math.cos(lo2 * coef)
  sinLo2 = Math.sin(lo2 * coef)
  x1 = cosLa1 * cosLo1
  y1 = cosLa1 * sinLo1
  z1 = sinLa1
  x2 = cosLa2 * cosLo2
  y2 = cosLa2 * sinLo2
  z2 = sinLa2
  u = y1 * z2 - y2 * z1
  v = z1 * x2 - z2 * x1
  w = x1 * y2 - x2 * y1
  cosT = x1 * x2 + y1 * y2 + z1 * z2
  sinT = Math.sqrt(Math.pow(u, 2) + Math.pow(v, 2) + Math.pow(w, 2))
  if (isZero(cosT)) {
    teta = Math.PI / 2
  } else {
    isZero(sinT) ? (teta = 0) : (teta = Math.atan(sinT / cosT))
    if (cosT < 0 && teta < 0) teta = teta + Math.PI
  }
  return Math.abs(teta) * terre
}

function calcCrow(lat1, lon1, lat2, lon2) {
  var R = 6371 // km
  var dLat = toRad(lat2 - lat1)
  var dLon = toRad(lon2 - lon1)
  lat1 = toRad(lat1)
  lat2 = toRad(lat2)

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  var d = R * c
  return d
}

// Converts numeric degrees to radians
function toRad(Value) {
  return (Value * Math.PI) / 180
}

/**
 * Returns distance in meters between two coordinates
 *
 * @param {*} coord1
 * @param {*} coord2
 * @returns
 */
export function distanceInMeters(coord1, coord2) {
  // Calculate difference in latitude and longitude
  const latDiff = coord1[0] - coord2[0]
  const lngDiff = coord1[1] - coord2[1]

  // Use basic distance formula
  const degrees = Math.sqrt(
    latDiff ** 2 + Math.cos(coord1[0]) * Math.cos(coord2[0]) * lngDiff ** 2
  )

  // Meters per degree gets adjusted for latitude
  const metersPerDegreeLat = 111320 * Math.cos(coord1[0])
  const metersPerDegreeLng = 111317.5

  // Multiply degrees by meters per degree at latitude
  const latMeters = degrees * metersPerDegreeLat
  const lngMeters = degrees * metersPerDegreeLng

  // Return total distance in meters
  return Math.sqrt(latMeters ** 2 + lngMeters ** 2)
}

/**
 * Returns bounds from a polygon array
 * Allows to dynamically compute new bounds from a polygon
 * @param polygon
 * @returns
 */
export function getBoundsFromPolygon(polygon) {
  //Return null if polygon is undefined or null
  if (!polygon) {
    return null
  }

  //Return null if polygon is not an array
  if (!Array.isArray(polygon)) {
    return null
  }

  //Return null if polygon doesnt contain valid latLng points
  if (!validatePolygon(polygon)) {
    return null
  }

  //Assign temp minLat, maxLat, minLng, maxLng
  let minLat = polygon[0][0]
  let maxLat = polygon[0][0]
  let minLng = polygon[0][1]
  let maxLng = polygon[0][1]

  //Compute real minLat, maxLat, minLng, maxLng
  polygon.forEach(([lat, lng]) => {
    if (lat < minLat) minLat = lat
    if (lat > maxLat) maxLat = lat
    if (lng < minLng) minLng = lng
    if (lng > maxLng) maxLng = lng
  })

  return L.latLngBounds([minLat, minLng], [maxLat, maxLng])
}

/**
 * Returns true if polygon is composed of valid points
 * @param polygon
 * @returns {*}
 */
export function validatePolygon(polygon) {
  if (typeof polygon === 'string') {
    polygon = parsePolygonString(polygon)

    if (!polygon) return false
  }

  if (!Array.isArray(polygon)) {
    return false
  }

  return polygon.every(isValidLatLng)
}

/**
 * Returns true is point has valid lat and lng
 * @param point
 * @returns {boolean}
 */
export function isValidLatLng(point) {
  if (!point) return false

  let lat, lng

  if (Array.isArray(point) && point.length === 2) {
    ;[lat, lng] = point
  } else if (typeof point === 'object' && 'lat' in point && 'lng' in point) {
    ;({ lat, lng } = point)
  } else {
    return false
  }

  // Check if both lat and lng are numbers and within valid ranges
  return (
    typeof lat === 'number' &&
    lat >= -90 &&
    lat <= 90 &&
    typeof lng === 'number' &&
    lng >= -180 &&
    lng <= 180
  )
}

/**
 * Returns true if layer and map bounds match
 * @param layer
 * @param mapBounds
 * @returns {boolean}
 */
export function getLayerAndMapBoundsMatch(layer, mapBounds) {
  if (!layer || !mapBounds) {
    console.error('Invalid layer or map bounds provided')
    return false
  }

  let boundsMatch

  try {
    const isPolygon =
      layer.polygon && Array.isArray(layer.polygon) && layer.polygon.length > 0
    const isCircle =
      isPolygon &&
      typeof layer.radius === 'number' &&
      layer.radius > 0 &&
      layer.polygon.length === 360

    if (isCircle) {
      // Create the circle bounds using the radius
      const southWest = L.latLng(
        layer.lat - layer.radius,
        layer.lng - layer.radius
      )
      const northEast = L.latLng(
        layer.lat + layer.radius,
        layer.lng + layer.radius
      )

      // Create the bounds using these two points
      const circleBounds = L.latLngBounds(southWest, northEast)

      // Check if the mapBounds intersects with the circleBounds
      boundsMatch = mapBounds.intersects(circleBounds)
    } else if (isPolygon) {
      const polygonBounds = L.latLngBounds(
        layer.polygon.map(([lat, lng]) => L.latLng(lat, lng))
      )
      boundsMatch = mapBounds.intersects(polygonBounds)
    } else {
      boundsMatch = mapBounds.contains(L.latLng(layer.lat, layer.lng))
    }
  } catch (error) {
    console.error('Error in getBoundsMatch:', error)
    boundsMatch = false
  }

  return boundsMatch
}

/**
 * Allows to parse a polygon string with structure like below
 * `(${sw.lng}%20${sw.lat},${ne.lng}%20${sw.lat},${ne.lng}%20${ne.lat},${sw.lng}%20${ne.lat},${sw.lng}%20${sw.lat})`
 * lng and lat pairs should be separated by %20
 * @param polygonString
 * @returns {*|null}
 */
export function parsePolygonString(polygonString) {
  try {
    // Remove parentheses
    polygonString = polygonString.trim()
    if (polygonString.startsWith('(') && polygonString.endsWith(')')) {
      polygonString = polygonString.slice(1, -1)
    } else {
      return null
    }

    // Split into coordinate pairs
    const points = polygonString.split(',').map((coord) => {
      const [lng, lat] = coord.split('%20').map(Number)
      if (isNaN(lng) || isNaN(lat)) return null
      return { lat, lng }
    })

    if (points.includes(null)) return null

    return points
  } catch (error) {
    return null
  }
}

//Here we store centroid coordinates for all our customers countries
//Feel free to add new coordinates if more countries are needed
export const countryCoordinates = {
  //France
  FR: [46.227638, 2.213749],
  //Spain
  ES: [40.463667, -3.74922],
  //Canada
  CA: [56.130366, -106.346771],
  //Belgium
  BE: [50.503887, 4.469936],
  //Benin
  BJ: [9.30769, 2.315834],
  //Ivory Coast
  CI: [7.539989, -5.54708],
  //Afghanistan
  AF: [33.93911, 67.709953],
  //Cameroon
  CM: [7.369722, 12.354722],
  //French Guiana
  GF: [3.933889, -53.125782],
  //Guadeloupe
  GP: [16.995971, -62.067641],
  //Guyana
  GY: [4.860416, -58.93018],
  //Morocco
  MA: [31.791702, -7.09262],
  //Monaco
  MC: [43.750298, 7.412841],
  //Martinique
  MQ: [14.641528, -61.024174],
  //New Caledonia
  NC: [-20.904305, 165.618042],
  //Réunion
  RE: [-21.115141, 55.536384],
  //Senegal
  SN: [14.497401, -14.452362],
  // Add more countries as needed
}

export function getDefaultMapCenterByCountryCode(countryCode) {
  // Set a fallback value to the centroid of France
  const defaultCenter = [46.227638, 2.213749]

  // Fallback to default center if countryCode is invalid
  if (
    !countryCode ||
    typeof countryCode !== 'string' ||
    countryCode.length !== 2
  ) {
    console.warn(`Invalid country code: ${countryCode}`)
    return defaultCenter
  }
  //Fallback to default center in case countryCode is not in the list
  return countryCoordinates[countryCode] || defaultCenter
}
